import "./index.scss";
export var Paragraph = function Paragraph(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "paragraph"
  }, children);
};